'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var borders = require('./borders.js');
var breakpoints = require('./breakpoints.js');
var colors = require('./colors.js');
var radius = require('./radius.js');
var shadows = require('./shadows.js');
var sizes = require('./sizes.js');
var space = require('./space.js');
var transition = require('./transition.js');
var typography = require('./typography.js');
var zIndex = require('./z-index.js');
var blur = require('./blur.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var foundations = _objectSpread(_objectSpread({
  breakpoints: breakpoints["default"],
  zIndices: zIndex["default"],
  radii: radius["default"],
  blur: blur["default"],
  colors: colors["default"]
}, typography["default"]), {}, {
  sizes: sizes["default"],
  shadows: shadows["default"],
  space: space["default"],
  borders: borders["default"],
  transition: transition["default"]
});
exports["default"] = foundations;